/* eslint-disable no-unused-vars */
import React, { useEffect, lazy, Suspense } from "react";
import { useState } from "react";
import candidateTabsviewStyle from "../../Candidate/CandidateTabsview.module.scss";

import { FaChartBar, FaUserCheck } from "react-icons/fa";
import { AiFillFunnelPlot } from "react-icons/ai";
import { PiUserCirclePlusBold, PiUserListFill } from "react-icons/pi";
import { TbCalendarUp } from "react-icons/tb";
import { GiDiscussion } from "react-icons/gi";
import { MdGroupAdd } from "react-icons/md";
import CandidateFunnelCount from "../../../pipelines/overallCountDetails/CandidateFunnelCount";
import { useSelector } from "react-redux";
import { GetCanLeadPipeline } from "../../../../apiServices";
import NewFollowUp from "../../../NewFollowUp/NewFollowUp";
import { BsCalendarPlus } from "react-icons/bs";
import DetailContainer from "../../../../components/CandidateDetailView/DetailContainer";

const InterviewPipeline = lazy(() =>
  import("../../../NewPipeline/InterviewPipeline/InterviewPipeline")
);
function PipelineTab() {  
  const [activeTab, setActiveTab] = useState(1);
  
    const [detailedCandidate, setDetailedCandidate] = useState({
      id: null,
      show : false,
    });

useEffect(() => {
  const hash = window.location.hash.replace("#", "");

  if (hash) {
    const [mainTab, subTab] = hash.split("-");

    setActiveTab(mainTab || "Interview");

    // store inner tab globally (temporary)
    window.__INNER_TAB__ = subTab || "active";
  } else {
    setActiveTab("Interview");
    window.__INNER_TAB__ = "active";
  }
}, []);
const handleTabClick = (tabValue) => {
  setActiveTab(tabValue);

  if (tabValue === "Interview") {
    const sub = window.__INNER_TAB__ || "active";
    window.location.hash = `Interview-${sub}`;
  } else {
    window.location.hash = tabValue;
  }
};
  // useEffect(() => {
  //   const hashValue = window.location.hash.substring(1);

  //   // Now 'hashValue' contains the value of the hash fragment

  //   if (hashValue) {
  //     switch (hashValue) {
  //       case "Interview":
  //         handleTabClick("Interview");
  //         break;
       

  //       default:
  //         handleTabClick("Interview");
  //         break;
  //     }
  //   } else {
  //     handleTabClick("Interview");
  //   }
  // }, []);
   const handleSelectCandidate = (candidate) => {
  setDetailedCandidate({ id: candidate.candidate_id, show: true });
};
 const handleSelectFollowupCandidate = (candidate) => {
  setDetailedCandidate({ id: candidate.candidateId, show: true });
};
  return (

    <>
  {/* ✅ KEEP PIPELINE ALWAYS MOUNTED */}
  <div style={{ display: detailedCandidate.show ? "none" : "block" }}>
    <div>
      <div className={`tab-buttons ${candidateTabsviewStyle.tab_buttons1}`}>
        <div className={`d-flex ${candidateTabsviewStyle.tab_hr}`}>
          
          <div
            onClick={() => handleTabClick("Interview")}
            className={`${
              activeTab === "Interview"
                ? candidateTabsviewStyle.activetag
                : candidateTabsviewStyle.unactivetag
            }`}
          >
            Interview
          </div>

          <div
            onClick={() => handleTabClick("NewFollowUp")}
            className={`${
              activeTab === "NewFollowUp"
                ? candidateTabsviewStyle.activetag
                : candidateTabsviewStyle.unactivetag
            }`}
          >
            New FollowUp
          </div>

        </div>
        <hr style={{ borderTop: "10px solid #ccc" }} />
      </div>

      <div className={`tab-content ${candidateTabsviewStyle.tab_content}`}>
        
        {activeTab === "Interview" && (
          <Suspense fallback={<div>Loading...</div>}>
            <InterviewPipeline onSelectCandidate={handleSelectCandidate} />
          </Suspense>
        )}

        {activeTab === "NewFollowUp" && (
          <Suspense fallback={<div>Loading...</div>}>
            <NewFollowUp onSelectCandidate={handleSelectFollowupCandidate} />
          </Suspense>
        )}

        {/* <CandidateFunnelCount /> */}
      </div>
    </div>
  </div>

  {detailedCandidate.show && (
    <DetailContainer
      candidateid={detailedCandidate.id}
      onBack={() =>
        setDetailedCandidate((prev) => ({
          ...prev,
          show: false,
        }))
      }
    />
  )}
</>
  );
}

export default PipelineTab;
